import type { TopbarNotificationConfig } from '@eliadmin/core/src/components/header/topbar-notification-types';
import { LuDot } from 'react-icons/lu';

export const TOPBAR_NOTIFICATION_CONFIG = {
  variant: 'content-marquee',
  messages: [
    'Rezervuje si termín ešte dnes! <a href="/rezervacia">Rezervačný formulár</a>',
    'Voľné termíny',
  ],
  renderer: 'raw',
  separator: <LuDot className="mx-0.5 h-10 w-10" />,
  dismissible: false,
  marqueeDuration: 8,
  respectReducedMotion: true,
  className: {
    root: 'flex h-10 w-full items-center overflow-hidden bg-primary sm:h-12',
    item: 'ea-topbar__content',
  },
} satisfies TopbarNotificationConfig;
